import BusinessCoverImage from '../assets/Business-landing-page.png';
import CustomerCoverImage from '../assets/Customer-landing-page.png';
import AboutUsImage from '../assets/about.png';
import AboutEffectImage from '../assets/About-effect.png';
import VisionImage from '../assets/Vision.png';
import addBusinessImage from '../assets/Add-business.png';
import WTOBackground from '../assets/WTO-background.png';
import SaleIncrease from '../assets/SaleIncrease.png';
import RangeOfSpot from '../assets/a-range-of-spot.png';
import GetSupport from '../assets/Get-support.png';
import Meeting from '../assets/Meeting.png';
import CategoriesImage from '../assets/Categories.png';
import DahabGuideImage from '../assets/dahab-guide.png';
import Customer from '../assets/Customer.png';
import Business from '../assets/Business.jpg';
import testService from '../assets/Service-test.png';
import { businessContentFeatures, addBusinessContentPoints } from './features';
import { samplePartners } from './siteConfig';

export interface PageSection {
  type: 'hero' | 'content' | 'featureListing' | 'partnerListing' | 'requestContact' | 'submitSpot' | 'categories' | 'serviceListing';
  props: any;
}

export interface PageConfig {
  navType: 'business' | 'customer' | 'about';
  sections: PageSection[];
}

// Home/Index Page
export const indexPageConfig: PageConfig = {
  navType: 'about',
  sections: [
    {
      type: 'content',
      props: {
        heading: 'Business User',
        href: '/business',
        intro: 'Through our previous experiences we have found that our clients have achieved at least twice the sales of our clients.',
        buttonLabel: 'Learn More',
        imageSrc: Business,
        direction: 'right',
      }
    },
    {
      type: 'content',
      props: {
        heading: 'End User',
        href: '/customer',
        intro: 'Through our previous experiences we have found that our clients have achieved at least twice the sales of our clients.',
        buttonLabel: 'Learn More',
        imageSrc: Customer,
        backgroundColor: '#f3f3f3',
      }
    },
  ]
};

// About Page
export const aboutPageConfig: PageConfig = {
  navType: 'about',
  sections: [
    {
      type: 'hero',
      props: {
        href: '#',
        imgsrc: AboutUsImage,
        title: 'About us',
        text: 'Where to spot Your Dreams in one place First Platform that merge between Talents & Places. This Platform created for the people who seeks a different vision of live through all the noises around them and escape to a place where they really find what they seeks. Places, Activities, Online Shopping Guide, Talents, Travel Guides, Food & Drinks, Online Services and Courses..etc'
      }
    },
    {
      type: 'content',
      props: {
        heading: 'Mission',
        href: '#',
        intro: 'The company aims to be the leading global pioneer in information technology by providing innovative solutions across all sectors. We are dedicated to offering the best opportunities for you to achieve your goals and access what you desire.',
        imageSrc: AboutEffectImage,
        direction: 'right',
        backgroundColor: '#f3f3f3',
      }
    },
    {
      type: 'content',
      props: {
        heading: 'Vision',
        href: '#',
        intro: 'We strive to advance the use of technology to create interconnected and easily accessible communities. Our goal is to provide all information in one place, allowing users to access it with a single click.',
        imageSrc: VisionImage,
      }
    },
    {
      type: 'partnerListing',
      props: {
        title: '"Join a large number of clients around the world and their unique experiences!"',
        partners: samplePartners,
      }
    },
  ]
};

// Business Page
export const businessPageConfig: PageConfig = {
  navType: 'business',
  sections: [
    {
      type: 'hero',
      props: {
        href: '/business/add-a-new-spot',
        labelButton: 'List Your Business',
        imgsrc: BusinessCoverImage,
        title: 'Let\'s Customer Discover',
        slogan: 'Their Favourite Spot!',
        text: 'Where small businesses shine brighter, shoppers uncover hidden treasures, and freelancers unlock endless possibilities all in one vibrant and growing community. Join us and explore a world of connections waiting to be discovered.'
      }
    },
    {
      type: 'content',
      props: {
        heading: 'Add Your Business',
        href: 'http://wa.me/+201277660666',
        intro: 'We offer you a new experience to join your new business, designed to facilitate the purchase process with us everything it can in one place.',
        points: addBusinessContentPoints,
        buttonLabel: 'Contact Us',
        imageSrc: addBusinessImage,
      }
    },
    {
      type: 'featureListing',
      props: {
        columns: businessContentFeatures,
        imageSrc: WTOBackground,
      }
    },
    {
      type: 'content',
      props: {
        heading: 'Increase Sales',
        href: 'http://wa.me/+201277660666',
        intro: 'Through our previous experiences we have found that our clients have achieved at least twice the sales of our clients.',
        buttonLabel: 'Contact Us',
        imageSrc: SaleIncrease,
        direction: 'right',
        backgroundColor: '#f3f3f3',
        buttonType: 'whatsapp',
      }
    },
    {
      type: 'partnerListing',
      props: {
        title: '"Join a large number of clients around the world and their unique experiences!"',
        partners: samplePartners,
      }
    },
    {
      type: 'requestContact',
      props: {}
    },
  ]
};

// Customer Page
export const customerPageConfig: PageConfig = {
  navType: 'customer',
  sections: [
    {
      type: 'hero',
      props: {
        href: 'https://www.wheretospot.com/blog',
        labelButton: 'Explore Spots',
        imgsrc: CustomerCoverImage,
        title: 'Discover Your',
        slogan: 'Next Favourite Spot!',
        text: 'Where small businesses shine brighter, shoppers uncover hidden treasures, and freelancers unlock endless possibilities all in one vibrant and growing community. Join us and explore a world of connections waiting to be discovered.'
      }
    },
    {
      type: 'featureListing',
      props: {
        columns: businessContentFeatures,
        imageSrc: WTOBackground,
      }
    },
    {
      type: 'content',
      props: {
        heading: 'A range of spots',
        href: 'http://wa.me/+201277660666',
        intro: 'Through our previous experiences we have found that our clients have achieved at least twice the sales of our clients.',
        buttonLabel: 'Learn More',
        imageSrc: RangeOfSpot,
      }
    },
    {
      type: 'content',
      props: {
        heading: 'Get Support',
        href: 'http://wa.me/+201277660666',
        intro: 'Through our previous experiences we have found that our clients have achieved at least twice the sales of our clients.',
        buttonLabel: 'Contact Us',
        imageSrc: GetSupport,
        direction: 'right',
        backgroundColor: '#f3f3f3',
        buttonType: 'whatsapp',
      }
    },
    {
      type: 'content',
      props: {
        heading: 'Experts Network',
        href: 'http://wa.me/+201277660666',
        intro: 'Through our previous experiences we have found that our clients have achieved at least twice the sales of our clients.',
        buttonLabel: 'Contact Us',
        imageSrc: Meeting,
        buttonType: 'whatsapp',
      }
    },
    {
      type: 'partnerListing',
      props: {
        title: '"Join a large number of clients around the world and their unique experiences!"',
        partners: samplePartners,
      }
    },
    {
      type: 'requestContact',
      props: {}
    },
  ]
};

// Add New Spot Page
export const addNewSpotPageConfig: PageConfig = {
  navType: 'business',
  sections: [
    {
      type: 'submitSpot',
      props: {}
    },
  ]
};

// Category Page
export const categoryPageConfig: PageConfig = {
  navType: 'customer',
  sections: [
    {
      type: 'hero',
      props: {
        href: '#',
        imgsrc: CategoriesImage,
        title: 'Categories',
        text: 'Where to spot Your Dreams in one place First Platform that merge between Talents & Places. This Platform created for the people who seeks a different vision of live through all the noises around them and escape to a place where they really find what they seeks. Places, Activities, Online Shopping Guide, Talents, Travel Guides, Food & Drinks, Online Services and Courses..etc'
      }
    },
    {
      type: 'categories',
      props: {
        categories: [
          { name: 'Category 1', href: '#category1' },
          { name: 'Category 2', href: '#category2' },
          { name: 'Category 3', href: '#category3' },
          { name: 'Category 4', href: '#category4' },
          { name: 'Category 5', href: '#category5' },
          { name: 'Category 6', href: '#category6' },
          { name: 'Category 7', href: '#category7' },
          { name: 'Category 8', href: '#category8' },
          { name: 'Category 9', href: '#category9' },
          { name: 'Category 8', href: '#category8' },
          { name: 'Category 9', href: '#category9' },
          { name: 'Category 8', href: '#category8' },
          { name: 'Category 9', href: '#category9' },
        ]
      }
    },
    {
      type: 'partnerListing',
      props: {
        title: '"Join a large number of clients around the world and their unique experiences!"',
        partners: samplePartners,
      }
    },
  ]
};

// Dahab Guide Page
export const dahabGuidePageConfig: PageConfig = {
  navType: 'customer',
  sections: [
    {
      type: 'hero',
      props: {
        href: 'http://wa.me/+201277660666',
        labelButton: 'Subscribe Now',
        imgsrc: DahabGuideImage,
        title: 'Dahab Travel Guide',
        slogan: 'A fun little artsy town',
        text: 'Dahab attracts large numbers of tourists. It is world-renowned for its windsurfing. Reliable winds provide superb flat-water conditions inside Dahab\'s sand spit.'
      }
    },
    {
      type: 'serviceListing',
      props: {
        title: 'Choose our services:',
        services: [
          {
            category: 'Category 1',
            items: [
              { image: testService, href: 'https://service1.com' },
              { image: testService, href: 'https://service1.com' },
              { image: testService, href: 'https://service1.com' },
              { image: testService, href: 'https://service2.com' },
            ],
          },
          {
            category: 'Category 2',
            items: [
              { image: testService, href: 'https://service1.com' },
              { image: testService, href: 'https://service1.com' },
            ],
          },
          {
            category: 'Category 3',
            items: [
              { image: testService, href: 'https://service1.com' },
            ],
          },
          {
            category: 'Category 4',
            items: [
              { image: testService, href: 'https://service3.com' },
              { image: testService, href: 'https://service4.com' },
              { image: testService, href: 'https://service1.com' },
            ],
          },
        ]
      }
    },
  ]
};
